import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import css from './ListingCardsCarouselSection.css';

import { ListingCardsCarouselWithMatchingScore } from '../../../../components';
import { useListingsWithDistance } from '../../../../hooks/useListingsWithDistance';
import { useSimilarOriginListingsRequest } from '../../hooks/useSimilarOriginListingsRequest';
import { parse } from '../../../../util/urlHelpers';
import { priceSearchParams } from '../../../SearchPage/SearchPage.helpers';
import { IconFilterM } from '../../../../icons';

const ListingCardsCarouselSection = ({
    viewport,
    currentListing,
    params: paramsProps,
    ...rest
}) => {
    const history = useHistory();
    const similarLocationListings = useSelector(s => s.ListingPage.similarLocationListings);

    const queryParams = parse(history.location.search);

    const { price, ...restParams } = queryParams;

    const priceMaybe = priceSearchParams(price);

    const params = {
        ...paramsProps,
        ...priceMaybe,
        ...restParams,
    };

    useSimilarOriginListingsRequest(params);

    /** useEffect */
    const listingsWithDistance = useListingsWithDistance(
        (similarLocationListings || []).filter(l => l?.id?.uuid !== currentListing?.id?.uuid),
        params.origin
    );

    if (!viewport) return null;
    if (!Array.isArray(listingsWithDistance)) return null;
    if (listingsWithDistance.length === 0) return null;

    const isDesktop = viewport > 768;
    const visibleSlidesByViewport = isDesktop ? 2 : 1;
    const isLoggedIn = rest.isLoggedIn;
    const filtersCount = Object.keys(restParams).length + Boolean(price);

    return (
        <ListingCardsCarouselWithMatchingScore
            sliderVisibleSlides={Math.min(visibleSlidesByViewport, listingsWithDistance.length)}
            listings={listingsWithDistance}
            header={
                <div className={css.sectionHeading}>
                    <h4>{isLoggedIn ? 'Beste Treffer' : 'Ganz in der Nähe'}</h4>
                    {Boolean(filtersCount) && (
                        <p>
                            <IconFilterM />
                            <span>{filtersCount} Filter aus Suche angewendet</span>
                        </p>
                    )}
                </div>
            }
            {...rest}
        />
    );
};

export default ListingCardsCarouselSection;
